import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const StudentRedirect = () => {
  const { user } = useAuth();
  
  // If user is a student (exact role match), redirect to generate exam page
  if (user && user.role === 'STUDENT') {
    return <Navigate to="/generate" replace />;
  }
  
  // Otherwise redirect to dashboard (for tutors and admins)
  return <Navigate to="/dashboard" replace />;
};

export default StudentRedirect;